import { ReactElement } from 'react'
import { useFormContext } from 'react-hook-form'
import { find } from 'lodash-es'
import { Stack } from '@mui/material'
import { Select } from '@ui/forms'
import {
  LoadCaseId,
  isReferencedLoadCaseType,
  loadCaseOptions,
  referenceLoadCaseOptions,
} from '../constants'

interface Props {
  value: LoadCaseId
  /** Form field of the live load category a stair or access load case (T1–T3, Z) takes its psi and KLED from */
  referenceName: string
  onSelect: (loadCase: {
    identifier: string
    category: LoadCategory
    loadCaseType: LoadCaseTypes
  }) => void
  disabled: boolean
}

const LoadCaseSelect = ({ value, referenceName, onSelect, disabled }: Props): ReactElement => {
  const { setValue } = useFormContext()

  const options = Object.entries(loadCaseOptions).map(([key, value]) => ({
    value: key,
    label: value.label,
  }))

  const isReferenced = isReferencedLoadCaseType(loadCaseOptions[value]?.loadCaseType)

  return (
    <Stack spacing={2}>
      <Select
        label="Lastfall auswählen"
        // as we overwrite onChange and value this does not matter
        name="undefined"
        options={options}
        onChange={e => {
          const option = find(loadCaseOptions, (v, key) => e.target.value === key)
          if (!option) return
          if (!isReferencedLoadCaseType(option.loadCaseType)) setValue(referenceName, null)
          onSelect(option)
        }}
        // options are composed of category and load case type, hence we can
        // safely set the value here like this (see definition of options)
        value={value}
        disabled={disabled}
      />
      {isReferenced && (
        <Select
          label="ψ-Werte und KLED wie"
          name={referenceName}
          placeholder="Nutzungskategorie des Gebäudes"
          options={referenceLoadCaseOptions}
          disabled={disabled}
          tooltip={{
            text: 'Treppen (Kategorie T) sowie Zugänge und Balkone (Kategorie Z) haben keine eigenen ψ-Werte und keine eigene Klasse der Lasteinwirkungsdauer. Sie übernehmen die der Nutzungskategorie des Gebäudes, zu dem sie gehören.',
          }}
          data-cy="reference-load-case-select"
        />
      )}
    </Stack>
  )
}

export default LoadCaseSelect
